// extracted by mini-css-extract-plugin
module.exports = {"loginButtons":"LoginForm_loginButtons__FJWdW"};